"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_OF_WEEK = exports.default = void 0;
var WeekDayFilter_1 = require("./WeekDayFilter");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(WeekDayFilter_1).default; } });
Object.defineProperty(exports, "DAYS_OF_WEEK", { enumerable: true, get: function () { return WeekDayFilter_1.DAYS_OF_WEEK; } });
//# sourceMappingURL=index.js.map